import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SimulationPage from "../pages/simulation/page";
import TermsPage from "../pages/terms/page";
import PrivacyPage from "../pages/privacy/page";
import AccessibilityPage from "../pages/accessibility/page";
import ResourcesPage from "../pages/resources/page";
import OverUnderMethodPage from "../pages/overunder-method/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/wake-county-simulation",
    element: <SimulationPage />,
  },
  {
    path: "/resources",
    element: <ResourcesPage />,
  },
  {
    path: "/overunder-method",
    element: <OverUnderMethodPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/accessibility",
    element: <AccessibilityPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;